<template>
	<BAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-primary="isPrimary"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:nullable="itemConfig.nullable"
		:expression="itemConfig.expression"
		v-if="itemConfig.type === 'B'"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData"
		:locked-edit="lockedEdit"
	/>
	<MultipleLAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:classificator-type="itemConfig.classificatorType"
		:is-value-classificators="itemConfig.valueClassificator"
		:classificators="classificators"
		:localization="localization"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData[attributeName]"
		v-else-if="itemConfig.type === 'L' && itemConfig.multiple"
		:locked-edit="lockedEdit"
	/>
	<SPrevValuesDictionaryEditor
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:max-length="itemConfig.maxLength"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:language="language"
		:prev-values-dictionary="prevValuesDictionary"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData[attributeName]"
		v-else-if="itemConfig.type === 'S' && itemConfig.prevValuesDictionary"
		:locked-edit="lockedEdit"
	/>
	<SAttributeEditorComponent
		:attribute-name="attributeName"
		:is-primary="isPrimary"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData"
		:item-config="itemConfig"
		v-else-if="itemConfig.type === 'S'"
		:locked-edit="lockedEdit"
	/>
	<DAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:nullable="itemConfig.nullable"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData[attributeName]"
		v-else-if="itemConfig.type === 'D'"
		:locked-edit="lockedEdit"
	/>
	<NAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData"
		:expression="itemConfig.expression"
		v-else-if="itemConfig.type === 'N'"
		:locked-edit="lockedEdit"
	/>
	<NMAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:measurement-units="measurementUnits[itemConfig.measurementUnitType]"
		:measurement-unit-type="itemConfig.measurementUnitType"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData"
		:expression="itemConfig.expression"
		v-else-if="itemConfig.type === 'NM'"
		:locked-edit="lockedEdit"
	/>
	<ImgAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:item-data="itemData[attributeName]"
		v-else-if="itemConfig.type === 'A'"
		:locked-edit="lockedEdit"
	/>
	<LAttributeEditorComponent
		:attribute-name="attributeName"
		:localized-title="itemConfig.title"
		:is-multiple="itemConfig.multiple"
		:is-primary="isPrimary"
		:max-count="itemConfig.maxCount"
		:default-value="itemConfig.defaultValue"
		:default-lock="itemConfig.defaultLock"
		:colspan="itemConfig.colspan"
		:localization="localization"
		:classificator-type="itemConfig.classificatorType"
		:is-value-classificators="itemConfig.valueClassificator"
		:classificators="classificators"
		:enable-copy-attribute-name="enableCopyAttributeName"
		:item-data="itemData[attributeName]"
		v-else-if="itemConfig.type === 'L'"
		:locked-edit="lockedEdit"
	/>
</template>

<script>
import BAttributeEditorComponent from './BAttributeEditorComponent'
import DAttributeEditorComponent from './DAttributeEditorComponent'
import SAttributeEditorComponent from './SAttributeEditorComponent'
import NAttributeEditorComponent from './NAttributeEditorComponent'
import SLAttributeEditorComponent from './SLAttributeEditorComponent'
import SPrevValuesDictionaryEditor from './SPrevValuesDictionaryEditor'
import SLPrevValuesDictionaryEditor from './SLPrevValuesDictionaryEditor'
import ImgAttributeEditorComponent from './ImgAttributeEditorComponent'
import LAttributeEditorComponent from './LAttributeEditorComponent'
import MultipleLAttributeEditorComponent from './MultipleLAttributeEditorComponent'
import NMAttributeEditorComponent from './NMAttributeEditorComponent'

export default {
	components: {
		BAttributeEditorComponent,
		DAttributeEditorComponent,
		SAttributeEditorComponent,
		NAttributeEditorComponent,
		SLAttributeEditorComponent,
		SPrevValuesDictionaryEditor,
		SLPrevValuesDictionaryEditor,
		ImgAttributeEditorComponent,
		LAttributeEditorComponent,
		MultipleLAttributeEditorComponent,
		NMAttributeEditorComponent
	},
	name: 'AttributeEditorComponent',
	computed: {

	},
	props: {
		attributeName: {
			type: String,
			default: ''
		},
		isPrimary: {
			type: Boolean,
			default: false,
		},
		prevValuesDictionary: {
			type: [Object, Array]
		},
		language: {
			type: Object
		},
		localization: {
			type: Object
		},
		classificators: {
			type: Object
		},
		measurementUnits: {
			type: Object
		},
		itemConfig: {
			type: Object
		},
		enableCopyAttributeName: {
			type: Boolean
		},
		itemData: {
			type: [Object, Array, Boolean, String, Number]
		},
		lockedEdit: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>

</style>
